import { render } from "./SetupTariffsModal.vue?vue&type=template&id=074b5c9a&scoped=true&ts=true"
import script from "./SetupTariffsModal.vue?vue&type=script&lang=ts"
export * from "./SetupTariffsModal.vue?vue&type=script&lang=ts"

import "./SetupTariffsModal.vue?vue&type=style&index=0&id=074b5c9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074b5c9a"]])

export default __exports__